<app-header></app-header>
<div class="content content-account">
  <div class="panel">
    <div class="container-fluid">
      <div class="row align-items-stretch">
        <div class="col-12 col-lg-auto content-account__nav">
          <div class="position-relative w-100 pt-3 back-list">
            <ul
              class="nav justify-content-around justify-content-lg-start flex-row flex-lg-column nav-pills"
              orientation="vertical"
            >
              <li class="nav-item--title">
                <a class="fw-semi-bold" (click)="back()">
                  <span class="me-3 fs-2">
                    <img
                      src="assets/icons/icon-back-list.svg"
                      alt="back"
                      class="icon-back"
                  /></span>
                  <span
                    class="ms-2"
                    i18n="@@patient_evaluationOverview_backPatientsListLink"
                    >Back to list</span
                  ></a
                >
              </li>
            </ul>
          </div>
          <div class="position-relative w-100 pt-7">
            <ul
              ngbNav
              #nav="ngbNav"
              [activeId]="navActive"
              (navChange)="changeNavActive($event)"
              class="nav justify-content-around justify-content-lg-start flex-row flex-lg-column nav-pills"
              orientation="vertical"
            >
              <li ngbNavItem="overview" class="nav-item--title">
                <a
                  ngbNavLink
                  title="Overview"
                  (click)="showProfile = false"
                  class="fw-semi-bold"
                >
                  <span class="icon overview-icon"> <img src="assets/icons/icon-overview.svg" alt="overview" /></span>
                  <span class="ms-2" i18n="@@common_evaluationMenu_overviewLink"
                    >Overview</span
                  ></a
                >
                <ng-template ngbNavContent>
                  <app-overview (emitEvaluationCode)="switchSurveysTab($event)"></app-overview>
                </ng-template>
              </li>
            </ul>
          </div>
          <div class="position-relative w-100 pt-3">
            <ul
              ngbNav
              #navTests="ngbNav"
              [activeId]="navActive"
              (navChange)="changeNavActive($event)"
              class="nav justify-content-around justify-content-lg-start flex-row flex-lg-column nav-pills"
              orientation="vertical"
            >
              <li class="nav-item--title">
                <span class="fw-semi-bold">
                  <span class="icon icon-title-sup"> <img src="assets/icons/icon-test.svg" alt="tests" /></span>
                  <span class="ms-2" i18n="@@common_evaluationMenu_testsTitle"
                    >Tests</span
                  >
                </span>
              </li>
              <li ngbNavItem="perimeter">
                <a
                  ngbNavLink
                  title="perimeter"
                  (click)="showProfile = false"
                  class="nav-link--no-icon fw-normal"
                >
                  <span
                    class="ms-6"
                    i18n="@@common_evaluationMenu_perimeterLink"
                    >Perimeter</span
                  ></a
                >
                <ng-template ngbNavContent>
                  <app-perimeter
                    [patientProfile]="patientProfile"
                  ></app-perimeter>
                </ng-template>
              </li>
              <li ngbNavItem="endurance">
                <a
                  ngbNavLink
                  title="endurance"
                  (click)="showProfile = false"
                  class="nav-link--no-icon fw-normal"
                >
                  <span
                    class="ms-6"
                    i18n="@@common_evaluationMenu_enduranceLink"
                    >Endurance</span
                  ></a
                >
                <ng-template ngbNavContent>
                  <app-endurance
                    [patientProfile]="patientProfile"
                  ></app-endurance>
                </ng-template>
              </li>
              <li ngbNavItem="vision">
                <a
                  ngbNavLink
                  title="vision"
                  (click)="showProfile = false"
                  class="nav-link--no-icon fw-normal"
                >
                  <span class="ms-6" i18n="@@common_evaluationMenu_visionLink"
                    >Vision</span
                  ></a
                >
                <ng-template ngbNavContent>
                  <app-vision [patientProfile]="patientProfile"></app-vision>
                </ng-template>
              </li>
              <li ngbNavItem="dexterity">
                <a
                  ngbNavLink
                  title="dexterity"
                  (click)="showProfile = false"
                  class="nav-link--no-icon fw-normal"
                >
                  <span
                    class="ms-6"
                    i18n="@@common_evaluationMenu_dexterityLink"
                    >Dexterity</span
                  ></a
                >
                <ng-template ngbNavContent>
                  <app-dexterity
                    [patientProfile]="patientProfile"
                  ></app-dexterity>
                </ng-template>
              </li>
              <li ngbNavItem="cognition">
                <a
                  ngbNavLink
                  title="cognition"
                  (click)="showProfile = false"
                  class="nav-link--no-icon fw-normal"
                >
                  <span
                    class="ms-6"
                    i18n="@@common_evaluationMenu_cognitionLink"
                    >Cognition</span
                  ></a
                >
                <ng-template ngbNavContent>
                  <app-cognition
                    [patientProfile]="patientProfile"
                  ></app-cognition>
                </ng-template>
              </li>
            </ul>
          </div>
          <div class="position-relative w-100 pt-3">
            <ul
              ngbNav
              #navSurveys="ngbNav"
              [activeId]="navActive"
              (navChange)="changeNavActive($event)"
              class="nav justify-content-around justify-content-lg-start flex-row flex-lg-column nav-pills"
              orientation="vertical"
            >
              <li class="nav-item--title">
                <span class="fw-semi-bold">
                  <span class="icon icon-title-sup"> <img src="assets/icons/icon-survey.svg" alt="surveys" /></span>
                  <span class="ms-2" i18n="@@common_evaluationMenu_surveysTitle"
                    >Surveys</span
                  >
                </span>
              </li>
              <li ngbNavItem="blcs">
                <a
                  ngbNavLink
                  title="blcs"
                  (click)="showProfile = false"
                  class="nav-link--no-icon fw-normal twolines"
                >
                  <span
                    class="ms-6 text-left"
                    i18n="@@common_evaluationMenu_blcsLink"
                    >BLCS
                  </span></a
                >
                <ng-template ngbNavContent>
                  <app-blcs [patientProfile]="patientProfile"></app-blcs>
                </ng-template>
              </li>
              <li ngbNavItem="bwcs">
                <a
                  ngbNavLink
                  title="bwcs"
                  (click)="showProfile = false"
                  class="nav-link--no-icon fw-normal twolines"
                >
                  <span
                    class="ms-6 text-left"
                    i18n="@@common_evaluationMenu_bwcsLink"
                    >BWCS</span
                  ></a
                >
                <ng-template ngbNavContent>
                  <app-bwcs [patientProfile]="patientProfile"></app-bwcs>
                </ng-template>
              </li>
              <li ngbNavItem="mfis5">
                <a
                  ngbNavLink
                  title="mfis5"
                  (click)="showProfile = false"
                  class="nav-link--no-icon fw-normal twolines"
                >
                  <span
                    class="ms-6 text-left"
                    i18n="@@common_evaluationMenu_mfis5Link"
                    >MFIS-5</span
                  ></a
                >
                <ng-template ngbNavContent>
                  <app-mfis5 [patientProfile]="patientProfile"></app-mfis5>
                </ng-template>
              </li>
              <li ngbNavItem="phq8">
                <a
                  ngbNavLink
                  title="phq8"
                  (click)="showProfile = false"
                  class="nav-link--no-icon fw-normal twolines"
                >
                  <span
                    class="ms-6 text-left"
                    i18n="@@common_evaluationMenu_phq8Link"
                    >PHQ-8</span
                  ></a
                >
                <ng-template ngbNavContent>
                  <app-phq8 [patientProfile]="patientProfile"></app-phq8>
                </ng-template>
              </li>
              <li ngbNavItem="sf36">
                <a
                  ngbNavLink
                  title="sf36"
                  (click)="showProfile = false"
                  class="nav-link--no-icon fw-normal twolines"
                >
                  <span
                    class="ms-6 text-left"
                    i18n="@@common_evaluationMenu_sf36Link"
                    >SF-36</span
                  ></a
                >
                <ng-template ngbNavContent>
                  <app-sf36 [patientProfile]="patientProfile"></app-sf36>
                </ng-template>
              </li>
              <li ngbNavItem="ps">
                <a
                  ngbNavLink
                  title="ps"
                  (click)="showProfile = false"
                  class="nav-link--no-icon fw-normal twolines"
                >
                  <span
                    class="ms-6 text-left"
                    i18n="@@common_evaluationMenu_psLink"
                    >PS</span
                  ></a
                >
                <ng-template ngbNavContent>
                  <app-ps [patientProfile]="patientProfile"></app-ps>
                </ng-template>
              </li>
            </ul>
          </div>
        </div>
        <div class="col content-account__detail-patient">
          <div class="row">
            <div class="col-12 content-account__detail-patient__header">
              <div class="d-flex justify-content-end">
                <ng-container
                  *appSkeletonLoader="
                    loading;
                    style: { height: '2.7rem', width: '15rem' }
                  "
                >
                  <button
                    type="button"
                    class="btn-secondary rounded-2 btn px-4 py-2 me-xxl-4"
                    (click)="showProfile = !showProfile"
                  >
                    <span
                      *ngIf="!showProfile"
                      i18n="@@patient_fileGeneralInformations_showDetails"
                      >Show details</span
                    >
                    <span
                      *ngIf="showProfile"
                      i18n="@@patient_fileGeneralInformations_closeDetails"
                      >close details</span
                    >
                  </button>
                </ng-container>
              </div>
              <div class="row mt-3">
                <div class="col-12">
                  <div class="d-flex align-items-center">
                    <div class="profile-img ms-xxl-6">
                      <ng-container
                        *appSkeletonLoader="
                          loading;
                          type: 'circle';
                          style: { height: '5.8rem', width: '5.8rem' }
                        "
                      >
                        <img
                          src="assets/img/img-patient-f.svg"
                          class="img-fluid patient-avatar"
                          alt="avatar"
                          *ngIf="
                            patientProfile.gender === gender.female;
                            else imgMaleAvatar
                          "
                        />
                        <ng-template #imgMaleAvatar>
                          <img
                            src="assets/img/img-patient-m.svg"
                            class="img-fluid patient-avatar"
                            alt="avatar"
                          />
                        </ng-template>
                      </ng-container>
                    </div>
                    <div class="mx-5 flex-fill">
                      <div class="header-title">
                        <ng-container
                          *appSkeletonLoader="loading; style: { width: '20%' }"
                        >
                          <span
                            class="text-uppercase fw-medium"
                            i18n="@@patient_fileGeneralInformations_headerTitle"
                            >Patient file</span
                          >
                        </ng-container>
                      </div>
                      <div class="header-name">
                        <ng-container
                          *appSkeletonLoader="
                            loading;
                            style: { height: '2.7rem', width: '60%' }
                          "
                        >
                          {{ patientProfile?.firstName }}
                          {{ patientProfile?.lastName }}
                        </ng-container>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div
              class="px-0"
              [ngClass]="{
                'd-none':
                  navSectionActive !== evaluationNavSections.overview ||
                  showProfile
              }"
              [ngbNavOutlet]="nav"
            ></div>
            <div
              [ngClass]="{
                'd-none':
                  navSectionActive !== evaluationNavSections.tests ||
                  showProfile
              }"
              [ngbNavOutlet]="navTests"
            ></div>
            <div
              [ngClass]="{
                'd-none':
                  navSectionActive !== evaluationNavSections.surveys ||
                  showProfile
              }"
              [ngbNavOutlet]="navSurveys"
            ></div>
            <div class="px-0" [ngClass]="{ 'd-none': !showProfile }">
              <app-detail-info
                [patientProfile]="patientProfile"
              ></app-detail-info>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
